/* eslint-disable class-methods-use-this */
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import INTEGRATIONS_URL, {
  integrationsUrl,
} from 'SharedDir/backend/endpoints/administration-integration';
import { CopyFormType } from 'SharedDir/declarations/copy';
import { Integrations } from 'SharedDir/declarations/integrations';

import SimpleApi from './simpleApi';

export default class AdministrationIntegrationApiClass extends SimpleApi<
  Integrations.IntegrationItem,
  Integrations.IntegrationItem,
  Integrations.IntegrationItem
> {
  constructor() {
    super(integrationsUrl);
  }

  async uploadXml(id: number, file: FileList) {
    const formData = new FormData();
    Array.from(file).forEach((f) => {
      formData.append('file', f);
    });
    formData.append('integrationId', String(id));
    return http({
      ...INTEGRATIONS_URL.INTEGRATION_SECTIONS.IMPORT_XML,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    });
  }

  async validateXml(id: number, file: FileList) {
    const formData = new FormData();
    Array.from(file).forEach((f) => {
      formData.append('file', f);
    });
    formData.append('integrationId', String(id));
    return http({
      ...INTEGRATIONS_URL.INTEGRATION_SECTIONS.VALIDATE_XML,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    });
  }

  async getUserSearchConfig(id: number) {
    const {
      data: { fields },
    } = await http(INTEGRATIONS_URL.INTEGRATION.USER_SEARCH_CONFIG_GET(id));

    return fields;
  }

  async setUserSearchConfig(id: number, fields) {
    const { data } = await http({
      ...INTEGRATIONS_URL.INTEGRATION.USER_SEARCH_CONFIG_SET(id),
      data: { fields },
    });

    return data.fields;
  }

  async copy(data: CopyFormType) {
    const { data: responseData } = (await http({
      ...INTEGRATIONS_URL.INTEGRATION.COPY(data.id),
      data,
    })) as AxiosResponse<Integrations.IntegrationItem>;

    return responseData;
  }
}
